import { Envs } from 'scbk-services/config/enums/envs';
import { useConfig } from 'scbk-services/config/hooks/useConfig';
import { getMockPath } from 'scbk-services/mock';

import { useEnvContext } from 'scbk-services/config/hooks/useEnvContext';
import { Modules } from '../enums';

export const useBaseUrl = () => {
    const { getConfig } = useConfig();
    const { getEnv } = useEnvContext();

    const createBaseUrlGetter =
        (domainKey: string, contextPathKey: string) => (useMock: boolean) => {
            const currentEnv = getEnv();
            const { [domainKey]: domain, [contextPathKey]: contextPath } = getConfig(
                Modules.COMMON,
            );

            // Scenario 1: Using Mock Data, return api path with mock prefix
            if (currentEnv === Envs.MOCK || useMock) {
                return getMockPath();
            }

            //로컬환경인경우 context path
            if (currentEnv === Envs.LOCAL) {
                return `${domain}${contextPath}`;
            }

            // Scenario 2: Running on mobile webview via file protocol, needs to add specific domain for the full API url
            if (window.location.origin.startsWith('file://')) {
                return `${domain}${contextPath}`;
            }
            // kong 도메인 생성
            else if ('kongDomain' === domainKey) {
                return `${domain}${contextPath}`;
            }
            // Scenario 3: Running on web server
            else if (domain !== window.location.origin) {
                // Scenario 3.1: Current selected env domain is not same as web app's domain(cors limitation), add 'currentEnv' value as prefix for proxy pass handle via web server
                // e.g. selected env: oat, api path: /ae/api/v4/security/initLogin -> /sit/ae/api/v4/security/initLogin
                // web server will handle proxy pass '/oat' for target 'https://oat.sc.com/'
                return `${currentEnv}${contextPath}`;
            }
            // Scenario 3.2: Current selected env domain is same as web server's domain(no cors limitation), just use contextPath, no need proxy pass
            else {
                return contextPath;
            }
        };

    const getExpBaseUrl = createBaseUrlGetter('expDomain', 'expContextPath');
    const getBsoiBaseUrl = createBaseUrlGetter('bsoiDomain', 'bsoiContextPath');
    const getKonghBaseUrl = createBaseUrlGetter('kongDomain', 'kongContextPath');

    return {
        getExpBaseUrl,
        getBsoiBaseUrl,
        getKonghBaseUrl,
    };
};
